import { useQuery } from '@tanstack/react-query';

import type { AdminHotelListItem } from 'app/typings/core/admin/hotels/hotelsList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useAdminHotelsList() {
  return useQuery<AdminHotelListItem[]>({
    queryKey: [CORE_QUERY_KEYS.hotels],
    queryFn: () => apiRequest({ path: ENDPOINTS.getHotels }),
    staleTime: Infinity,
  });
}
